import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormLabel from '@material-ui/core/FormLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink,useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Css start for this components ...
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    display: 'flex'
  },
  signMain: {
    position: 'fixed',
    width: '100%',
    background: 'rgba(0,0,0,.5)',
    height: '100vh',
    top: '0',
    zIndex:'1'
  },
  signInBtn: {
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background: 'rgba(36, 97, 142, 1)!important',
    fontSize: '12px',    
    '@media only screen and (max-width: 3500px)': {
      width: '185px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '300px',
      marginBottom:'10px',
    },
  },
  formLogo: {
    textAlign: 'center',
    width: '100%',
    paddingTop: '15px',
    '& p': {
      textAlign: 'right',
      margin: '0px 0 -20px',
      paddingRight: '15px',
      fontSize: '25px',
    },
    '& a': {
      color: '#24618E',
    }
  },
  rootForm: {    
    margin: '10px auto 0',
    border: '1px solid rgba(0, 167, 93, 1)',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '1px 4px 5px 1px #ccc',
    '@media only screen and (max-width: 3500px)': {
      width: '80%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '85%',
    },
    '& input#email': {
      padding: '10px',
    },
    '& input#password': {
      padding: '10px',
    },
    '& h3': {
      color: '#24618E',      
      marginTop: '0px',
      marginBottom: '0',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '26pt',
      },
    }
  },
  formInput: {
    width: '100%',
  },
  OtherLink: {
    width: '80%',
    margin: '0 auto',
    '& a': {
      color: '#24618E',
    }
  },
  errIcon: {
    fontSize: '26px',
    color: '#CC0000',
    margin: '2%'
  },
  errorInput: {
    width: '100%',
    backgroundColor: '#F2DEDE',
    border: '1px solid #CC0000'
  },  
  errMsgForgot : {
    '& span' : {
      fontSize:'11pt !important'
  }
},
userFormContainer: {
  '@media only screen and (max-width: 3500px)': {
    width: '500px',
    paddingTop: '90px',
  },
  '@media only screen and (min-width: 3501px)': {
    width: '650px',
    maxWidth: '650px',
    paddingTop: '250px',
    '& input': {
      fontSize: '22pt',
    }
  },
},
closeIcon: {
  '&:hover': {
    color: '#CC0000',
  }
},
formIcon:{
  '@media only screen and (max-width: 3500px)': {
    width: '215px', 
    height:'50px'
  },
  '@media only screen and (min-width: 3501px)': {
    width: '300px', 
    height:'70px'
  },
}
}));
//Css end for this components ...

//Start Forgotpassword component code ....
export default function Forgotpassword() {
  const [spacing, setSpacing] = React.useState(2);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(null);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [values, setValues] = React.useState({
    email: "",
  });
  const classes = useStyles();
  let history = useHistory();  


  const handleChange = name => event => { // get values from form
    setErrEmail(false);
    setValues({ ...values, [name]: event.target.value });
  }

  // method to show error message popup ...
  const ShowErrPopUP = () => { 
    setErrPopUp(false);
  };
  // method to show error message popup ...

  //This method use for form validations start ...
  const validateForm = async e => {
    setErrMsg(null);
    e.preventDefault();    
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (values.email == '') {
      setErrEmail(true);
      setErrMsg('Email required');
      setErrPopUp(true);
    } else if (!checkEmail.test(values.email)) {
      setErrEmail(true);
      setErrMsg('Email format must be like yourname@example.com');
      setErrPopUp(true);
    } else {
      requestCode();
    }
  }
  //This method use for form validations end ...


  // API call to request verification code to recover password .. start
  const requestCode = () => { 
    try {
      axios({
        method: 'post',
        data: {'email' :  values.email},
        url: API_URL + API_PATH.forgotPasswordAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            await Cookies.set('email', values.email);
            history.push('/reset_password');
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error');
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true);
          } else {
            setErrMsgType('error');
            setErrMsg('Something went wrong.');
            setErrPopUp(true);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  // API call to request verification code to recover password .. end
  

  return (
    <React.Fragment>
      <Header />
      <CssBaseline />
      <div className={classes.signMain}>
        <Container maxWidth="sm" className={classes.userFormContainer}>
          <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', }}>
            <div className={classes.formLogo}>
              <p><NavLink className={classes.closeIcon} to="/" title='Close'><FontAwesomeIcon icon={faTimes} title='Close'/></NavLink></p>
              <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
            </div>
            {errMsg ? <div className={classes.errMsgForgot}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div>: null}
            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)}>
              <h3>Forgot Your Password?</h3>
              <img src={require('../../assets/images/hrimg.svg')} style={{ marginBottom: '10px',width: '100%', height: '1px' }} />
              <Grid container className={classes.rootBox} spacing={spacing}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <p>Enter the email associated with your account and we'll send a link that will help you reset your password.</p>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="email" data-testid="email" className={errEmail ? classes.errorInput : classes.formInput} placeholder="Email *" type="email" variant="outlined" required onChange={handleChange('email')} />
                        {errEmail ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="submit" variant="outlined" id="signIn_btn" data-testid="forgotPwdBtn" className={classes.signInBtn}>
                          Send Reset Code
                        </Button>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
            <div className={classes.OtherLink}>
              <p style={{ marginBottom: '5px' }}><NavLink to="/sign_in" data-testid="signInLink" >Sign In</NavLink></p>
              <p style={{ marginTop: '5px' }}><NavLink to="/sign_up" data-testid="signUpLink" >Sign up for an account</NavLink></p>
            </div>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}
//End Forgotpassword component code ....
